'use strict';

import modalTemplate from './modal.html';


export default function($uibModal) {
	'ngInject';

	return {
		link: postLink,
	};

	function postLink(scope, element, attrs) {
		element.on('click', function(event) {
			event.preventDefault();
			$uibModal.open({
				template: modalTemplate,
			});
		});
	}
}
